import { render, staticRenderFns } from "./NYTLatestList.vue?vue&type=template&id=7ec9c15d&scoped=true"
import script from "./NYTLatestList.vue?vue&type=script&lang=js"
export * from "./NYTLatestList.vue?vue&type=script&lang=js"
import style0 from "./NYTLatestList.vue?vue&type=style&index=0&id=7ec9c15d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec9c15d",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NYTLatest: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/NYTLatest/NYTLatest.vue').default})
